import { Stack, useMediaQuery, useTheme } from '@rabex-kit/rabex-ui';
import RegisterMockUp from '../../static/images/svg/auth/Register.svg';
import DarkRegisterMockUp from '../../static/images/svg/auth/Register-dark.svg';

const MockUp = () => {
  const { palette, breakpoints } = useTheme();
  // Not rendered below lg, so phones never download the art.
  const isMobile = useMediaQuery(breakpoints.down('lg'));
  if (isMobile) return null;
  return (
    <Stack
      sx={{
        zIndex: 1,
        maxWidth: 656,
        position: 'relative',
        width: 656,
        height: 613,
        overflow: 'visible',
        userSelect: 'none', // Prevent selection
        pointerEvents: 'none', // Disable pointer events (like clicking, dragging)
        top: '-169px',
        right: '-60px'
      }}>
      <img
        src={palette.mode === 'light' ? RegisterMockUp : DarkRegisterMockUp}
        alt="mockup"
        style={{
          zIndex: 2,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          userSelect: 'none', // Prevent selection
          pointerEvents: 'none' // Disable pointer events (like clicking, dragging)
        }}
        draggable="false" // Disable dragging the image
      />
      {/* <Stack
        width={11}
        height={11}
        borderRadius={20}
        top={161}
        left={245}
        bgcolor={palette.warning.A80}
        position="absolute"
        zIndex={3}
        sx={{
          animation:
            '5s linear 0.5s infinite normal none running motion_yellow',
          userSelect: 'none',
          pointerEvents: 'none'
        }}
      />
      <Stack
        width={11}
        height={11}
        borderRadius={20}
        top={315}
        left={215}
        bgcolor={palette.primary.A80}
        position="absolute"
        zIndex={3}
        sx={{
          animation: '5s linear 0.5s infinite normal none running motion_blue',
          userSelect: 'none',
          pointerEvents: 'none'
        }}
      />
      <Stack
        width={11}
        height={11}
        borderRadius={20}
        bottom={171}
        right={280}
        bgcolor={palette.error.A80}
        position="absolute"
        zIndex={3}
        sx={{
          animation: '5s linear 0.5s infinite normal none running motion_red',
          userSelect: 'none',
          pointerEvents: 'none'
        }}
      />
      <Stack
        width={11}
        height={11}
        borderRadius={20}
        top={265}
        right={191}
        bgcolor={palette.success.A80}
        position="absolute"
        zIndex={3}
        sx={{
          animation: '5s linear 0.5s infinite normal none running motion_green',
          userSelect: 'none',
          pointerEvents: 'none'
        }}
      /> */}
      <Stack
        sx={{
          opacity: 0.6,
          top: '170px',
          left: '-200px',
          height: '571px',
          width: '571px',
          position: 'absolute',
          zIndex: -1,
          '@media (prefers-reduced-motion: no-preference)': {
            animation: 'fadeInOut 12s linear infinite'
          },
          background:
            'radial-gradient(285px, rgba(255, 201, 0, 0.25) 0%, rgba(0, 0, 0, 0) 95%)',
          userSelect: 'none',
          pointerEvents: 'none'
        }}
      />
      <Stack
        sx={{
          opacity: 0.6,
          top: '200px',
          left: '130px',
          height: '591px',
          width: '591px',
          position: 'absolute',
          zIndex: -1,
          '@media (prefers-reduced-motion: no-preference)': {
            animation: 'fadeInOut 14s linear infinite'
          },
          background:
            'radial-gradient(295px, rgba(0, 255, 137, 0.25) 0%, rgba(0, 0, 0, 0) 95%)'
        }}
      />
      <Stack
        sx={{
          opacity: 0.6,
          top: '100px',
          left: '0px',
          height: '611px',
          width: '611px',
          position: 'absolute',
          zIndex: -1,
          '@media (prefers-reduced-motion: no-preference)': {
            animation: 'fadeInOut 10s linear infinite'
          },
          background:
            'radial-gradient(305px, rgba(100, 0, 255, 0.22) 0%, rgba(0, 0, 0, 0) 95%)',
          userSelect: 'none',
          pointerEvents: 'none'
        }}
      />
    </Stack>
  );
};

export default MockUp;
